const Trigger_Filter_Prefix = "Custom";
const Trigger_Filter_Suffix = "On";
const Date_Long = "M/D/YYYY HH:mm Z";
const Date_Short = "M/D/YYYY Z";
const Not_Available = "-";
const Custom_Where = "CustomWhere";
export {
  Custom_Where,
  Date_Long,
  Date_Short,
  Not_Available,
  Trigger_Filter_Prefix,
  Trigger_Filter_Suffix
};
//# sourceMappingURL=FormatConstants.js.map
